// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3fcWa","left":"InfoRow_left__4O8yC"};